import { useLocale } from "@/contexts/localeContext";
import { provisionOssCard } from "@/services/ossDeviceService";
import { getErrorMessage } from "@/services/utilities/ServiceError";
import { Form, Formik } from "formik";
import { FC, useState } from "react";
import Modal from 'react-modal';
import { toast } from "react-toastify";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import closeIcon from '../../images/close.svg';
import ActivityFrame from "../activity-frame/activity-frame";
import { useDialog } from "../dialog/DialogContext";
import ProvisionCardFormContent from "./ProvisionCardFormContent";

interface ProvisionCardModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ProvisionCardModal: FC<ProvisionCardModalProps> = ({ isOpen, onClose }) => {
    const { translate } = useLocale();
    const [busy, setBusy] = useState<boolean>(false);
    const dialog = useDialog();
    let initialValues = {
        typeId: "",
        credentialType: "0"
    }

    const onProvision = (values) => {
        setBusy(true);
        provisionOssCard(parseInt(values.cardTypeId), parseInt(values.credentialType)).then(() => {
            toast.success(translate.byKey(TranslationKeys.cardProvisionedSuccessfully));
        }).catch((error) => {
            dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(error) });
        }).finally(() => {
            setBusy(false);
        });

        initialValues = {
            typeId: values.typeId,
            credentialType: "0" // Reset to standard on form after provisioning
        };
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
            <div className="flex flex-row">
                <p className="pl-1 font-bold font text-white">{translate.byKey(TranslationKeys.ossCardProvision)}</p>
            </div>
            <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
        </div>
        <div className="py-3 px-3" style={{ width: '330px', height: "180px" }} >
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onProvision}>
                <Form name="provisionCardForm">
                    <ActivityFrame className="flex flex-col justify-between h-full" busy={busy} busyMessage={translate.byKey(TranslationKeys.provisionLoadingMessage)} >
                        <ProvisionCardFormContent />
                    </ActivityFrame>
                </Form>
            </  Formik>
        </div>
    </Modal>
}

export default ProvisionCardModal;